import React from 'react';
import PropTypes from 'prop-types';

import './EduExpListContainer.scss';
import CommonCardShell from '../../../Layout/CommonCardShell/CommonCardShell';
import AddCta from '../Modules/AddCta/AddCta';
import PersonalHistoryList from '../Modules/PersonalHistoryList/PersonalHistoryList';
import EmptyMessage from '../Modules/EmptyMessage/EmptyMessage';
import { personalHistoryShape } from '../../../Includes/userProps';
import { PageContext } from '../../../../contexts/ContextCreator';
import FGBLabel from '../../../Elements/FGBLabel/FGBLabel';
import { singleEducationFlowType } from '../../../Modals/Flows/SingleEducation/SingleEducation';
import { singleExperienceFlowType } from '../../../Modals/Flows/SingleExperience/SingleExperience';
import { capitalize } from '../../../../utilities/helperFunctions';
import { buildInitialFormState } from '../../../../contexts/Includes/modalContextHelpers';
import { getEducationId } from '../../../Modals/Flows/SingleEducation/constants';
import { getExperienceId } from '../../../Modals/Flows/SingleExperience/constants';

export default class EduExpListContainer extends React.PureComponent {
    constructor(props) {
        super(props);

        this.baseClassName = 'component-Users-UserProfile-EduExpListContainer';
    }

    static propTypes = {
        /**
         * list type
         */
        listType: PropTypes.oneOf(['education', 'experience']).isRequired,
        /**
         * whether this component is being viewed as public
         */
        isPublic: PropTypes.bool.isRequired,
        /**
         * list of serialized experiences or educations for displaying
         */
        serializedPersonalHistoryList: PropTypes.arrayOf(personalHistoryShape)
            .isRequired,
        /**
         * list of raw experiences or educations
         */
        rawPersonalHistoryList: PropTypes.array.isRequired,
        // function to set parent state with new exp/edu array on successful add/delete api request
        updateHistoryList: PropTypes.func.isRequired,
    };

    static defaultProps = {
        listType: '',
        isPublic: true,
        serializedPersonalHistoryList: [],
        rawPersonalHistoryList: [],
    };

    static contextType = PageContext;

    handleAddCtaClick = () => {
        const {
            listType,
            rawPersonalHistoryList,
            updateHistoryList,
        } = this.props;
        const { triggerFlowModal } = this.context;

        const rawHistoriesWithId = rawPersonalHistoryList.map((item) => {
            const newId =
                listType === 'experience'
                    ? getExperienceId(item)
                    : getEducationId(item);
            return {
                ...item,
                id: newId,
            };
        });

        const stepPropKey = `single${capitalize(listType)}`;
        const generalPropKey = `${listType}s`;

        const generalModalProps = {
            [generalPropKey]: rawHistoriesWithId, // array of existing educations/experiences to build api payload
            updateHistoryList,
        };

        const modalData = {
            stepPopulateProps: buildInitialFormState([stepPropKey], {}), // adding a new edu/exp so no default data
            generalModalProps,
        };

        const flowType =
            listType === 'experience'
                ? singleExperienceFlowType
                : singleEducationFlowType;

        return triggerFlowModal(flowType, modalData);
    };

    getEmptyMessage = (listType) => {
        if (listType === 'education') {
            return 'You worked hard for your education. Share the highlights.';
        }

        if (listType === 'experience') {
            return 'Showcase your professional accomplishments.';
        }

        return '';
    };

    render() {
        const {
            listType,
            isPublic,
            serializedPersonalHistoryList,
            rawPersonalHistoryList,
            updateHistoryList,
        } = this.props;
        const emptyHistory = serializedPersonalHistoryList.length === 0;
        const emptyMessage = this.getEmptyMessage(listType);

        if (emptyHistory && isPublic) {
            return null;
        }

        return (
            <CommonCardShell className={`${this.baseClassName}`}>
                <div className={`${this.baseClassName}__header`}>
                    <FGBLabel className={`${this.baseClassName}__header__text`}>
                        {listType}
                    </FGBLabel>

                    {!isPublic && (
                        <AddCta handleClick={this.handleAddCtaClick} />
                    )}
                </div>

                <div className={`${this.baseClassName}__body`}>
                    {emptyHistory ? (
                        <EmptyMessage
                            text={emptyMessage}
                            handleClick={this.handleAddCtaClick}
                        />
                    ) : (
                        <PersonalHistoryList
                            updateHistoryList={updateHistoryList}
                            serializedPersonalHistoryList={
                                serializedPersonalHistoryList
                            }
                            rawPersonalHistoryList={rawPersonalHistoryList}
                            showEditButton={!isPublic}
                            collapseShowCount={3}
                        />
                    )}
                </div>
            </CommonCardShell>
        );
    }
}
